import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

// La ruta base que definimos en el router.register del backend
export const baseURI = 'nominas/solicitudes-plazas';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Solicitudes Plazas
 * @param {object} params - Filtros (ej. { solicitud: 123 })
 * @returns {Promise<object[]>}
 */
export const getSolicitudesPlazasDetalles = async (params = {}) => {
  try {
    // Pasamos 'params' para poder filtrar por el ID de la solicitud padre
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Solicitud Plaza (Individual)
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getSolicitudPlazaDetalle = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Solicitud Plaza
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSolicitudPlazaDetalle = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Solicitud Plaza
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchSolicitudPlazaDetalle = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Solicitud Plaza
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteSolicitudPlazaDetalle = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Solicitud Plaza (Opcional, si usas lógica de autorización específica)
 * Si solo cambias el estatus a 2, puedes usar patchSolicitudPlaza,
 * pero si tienes un endpoint 'autorizar', sería así:
 */
export const autorizarSolicitudPlazaDetalle = async (id) => {
  try {
    // Asumiendo que autorizar es cambiar estatus a 2
    const values = { estados_globales: 2 };
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
